enum PropertyCategoryEnum {
    Commercial = 'COMMERCIAL',
    Residential = 'RESIDENTIAL',
    RuralResidential = 'RURAL_RESIDENTIAL',
}

export default PropertyCategoryEnum;